// @flow
import React from "react";
import { connect } from "react-redux";
import { useI18n } from "@quantum/i18n";
import SelecaoIndicesEBenchmarksPersonalizados from "../indice/SelecaoIndicesEBenchmarksPersonalizados";
import {
  type ActionCreator,
  selecionarAtivoSemRisco,
  selecionarPrimeiroAtivoSemRisco,
  getAtivoSemRiscoSelecionado,
} from "../../../../state";

type Prop = {
  ativoSemRiscoSelecionado: string,
  datasAtivoSemRiscoSelecionado: string,
  selecionarAtivoSemRisco: ActionCreator,
  selecionarPrimeiroAtivoSemRisco: ActionCreator,
};

function SelecaoAtivoSemRisco({
  ativoSemRiscoSelecionado,
  selecionarAtivoSemRisco,
  selecionarPrimeiroAtivoSemRisco,
}: Prop) {
  const { translate } = useI18n();

  function handleAtivoSemRiscoSelecionado(ativoSemRisco) {
    selecionarAtivoSemRisco(ativoSemRisco);
  }

  return (
    <div>
      <SelecaoIndicesEBenchmarksPersonalizados
        labelSelecao={translate("maiusculas.ativoSemRisco")}
        indiceSelecionado={ativoSemRiscoSelecionado}
        onChange={handleAtivoSemRiscoSelecionado}
        selecionarPrimeiroIndice={selecionarPrimeiroAtivoSemRisco}
        selecionarIndice={selecionarAtivoSemRisco}
      />
    </div>
  );
}

export default connect(
  state => ({
    ativoSemRiscoSelecionado: getAtivoSemRiscoSelecionado(state),
  }),
  { selecionarAtivoSemRisco, selecionarPrimeiroAtivoSemRisco }
)(SelecaoAtivoSemRisco);
